import React, { useEffect } from "react";
import "./ModalBox.css";

export default function ModalBox({
    open,
    onClose,
    title,
    children,
    className = "",
    disableBackdrop = false,
    hideCloseButton = false,
}) {
    useEffect(() => {
        if (!open) return;
        // prevent background scroll
        const previous = document.body.style.overflow;
        if (!disableBackdrop) {
            document.body.style.overflow = "hidden";
        }
        // handle Escape key press
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);


        return () => {
            document.body.style.overflow = previous;
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onClose]);


    if (!open) return null;

    if (disableBackdrop) {
        return (
            <div className="modal-center">
                <div className={`modal-box ${className}`}>

                    {/* header / title */}
                    {title && (
                        <div className="modal-header">
                            <h2 id="modal-title">{title}</h2>
                            {!hideCloseButton && (
                                <button
                                    onClick={onClose}
                                    aria-label="Close modal"
                                    className="modal-close"
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    )}

                    {/* body */}
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal-overlay" aria-modal="true" role="dialog">
            <div className="modal-backdrop" onClick={onClose} data-testid="modal-overlay" />

            {/* white box */}
            <div className="modal-container">
                <div className={`modal-box ${className}`}>

                    {/* header / title */}
                    {title && (
                        <div className="modal-header">
                            <h2 id="modal-title">{title}</h2>
                            {!hideCloseButton && (
                                <button
                                    onClick={onClose}
                                    aria-label="Close modal"
                                    className="modal-close"
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    )}

                    {/* body */}
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
}